export default "__VITE_ASSET__C$4gm9Sp__"